import React, {
  FC,
  useCallback,
  useEffect,
  useRef,
  useState,
  useLayoutEffect,
} from "react";
import {Dropdown} from "react-bootstrap";
import IconArrowDown from "../assets/icons/arrow-down.svg";
import "./CustomDropdown.css";
import {IAuthority} from "../pages/StateInitiative/StateInitiative.type";
import {ITypeRadar} from "../types";
import {IconContainer} from "../components/ClusterFilter/styles";

interface IProps {
  authorities?: IAuthority[];
  onFilterChange: <T>(filter: string, value?: T) => void;
  title?: string;
  typeRadar: ITypeRadar;
  isResetFilters?: boolean;
  setIsResetFilters?: React.Dispatch<React.SetStateAction<boolean>>;
}

export const MySelectWithCheckbox: FC<IProps> = ({
  authorities,
  onFilterChange,
  title,
  typeRadar,
  isResetFilters,
  setIsResetFilters,
}) => {
  const dropdownRef = useRef<HTMLDivElement>(null);
  const [dropdownMaxHeight, setDropdownMaxHeight] = useState<
    number | undefined
  >(undefined);

  const [isOpen, setIsOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  const options = useCallback(() => {
    return (
      authorities?.map((authority) => ({
        documentId: authority.documentId,
        label: authority.name,
        img: authority.logo
          ? typeof authority.logo === "string"
            ? authority.logo
            : authority.logo.url
          : null,
      })) || []
    );
  }, [authorities]);

  const [selectedOptions, setSelectedOptions] = useState<string[]>(
    [] as string[]
  );

  useEffect(() => {
    if (isResetFilters) {
      const optionsValue = options();
      if (optionsValue) {
        setSelectedOptions(
          optionsValue.map((option) => String(option.documentId))
        );
      }
    }
  }, [isResetFilters, options]);

  const onFilterChangeRef = useRef(onFilterChange);

  useEffect(() => {
    onFilterChangeRef.current = onFilterChange;
  });

  useEffect(() => {
    const optionsValue = options();
    const allOptions = optionsValue?.map((option) => option.documentId) ?? [];
    setSelectedOptions(allOptions);
  }, [options]);

  useEffect(() => {
    // Используем стабильную ссылку для предотвращения бесконечных вызовов
    onFilterChangeRef.current("drivers", selectedOptions);
  }, [selectedOptions]);

  // const [dropdownOpen, setDropdownOpen] = useState(false);

  const handleCheckboxChange = (value: string) => {
    setSelectedOptions((prevSelected) =>
      prevSelected.includes(value)
        ? prevSelected.filter((option) => option !== value)
        : [...prevSelected, value]
    );
    if (setIsResetFilters) setIsResetFilters(false);
  };

  // const handleToggle = (isOpen: boolean, metadata: any) => {
  //   if (metadata.source === "select") {
  //     return;
  //   }
  //   setDropdownOpen(isOpen);
  // };

  const handleSelectAll = () => {
    const optionsValue = options();
    if (selectedOptions.length === optionsValue?.length) {
      setSelectedOptions([]);
    } else {
      if (optionsValue) {
        setSelectedOptions(
          optionsValue.map((option) => String(option.documentId))
        );
      } else {
        setSelectedOptions([]);
      }
    }
    if (setIsResetFilters) setIsResetFilters(false);
  };
  const optionsLevel = options()?.length;

  useLayoutEffect(() => {
    if (isOpen && dropdownRef.current && ref.current) {
      // Оптимизируем getBoundingClientRect с requestAnimationFrame
      requestAnimationFrame(() => {
        if (!isOpen || !ref.current) return;

        const rect = ref.current.getBoundingClientRect();
        const minMargin = 16;
        const spaceBelow = window.innerHeight - rect.bottom - minMargin;
        const spaceAbove = rect.top - minMargin;
        const desiredMaxHeight = 1000;

        let maxHeight = desiredMaxHeight;

        if (spaceBelow < desiredMaxHeight && spaceBelow > spaceAbove) {
          maxHeight = spaceBelow > 100 ? spaceBelow : 100;
        } else if (spaceAbove < desiredMaxHeight) {
          maxHeight = spaceAbove > 100 ? spaceAbove : 100;
        }

        setDropdownMaxHeight(maxHeight);
      });
    }
  }, [isOpen]);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (ref.current && !ref.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };
    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen]);

  return (
    <IconContainer ref={ref}>
      <div
        style={{
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
        onClick={() => setIsOpen(!isOpen)}
      >
        <div style={{display: "flex", alignItems: "center", gap: "8px"}}>
          {title || "Драйверы"}
          <span
            style={{
              backgroundColor: "#56B9F2",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              borderRadius: "50%",
              width: "20px",
              height: "20px",
              color: "white",
              padding: "2px 8px",
            }}
          >
            {selectedOptions.length}
          </span>
        </div>
        <img src={IconArrowDown} alt="arrow" />
      </div>
      {isOpen && (
        <div
          ref={dropdownRef}
          style={{
            position: "absolute",
            left: 0,
            right: 0,
            bottom: 60,
            // padding: "8px 0",
            borderRadius: "12px",
            border: "1px solid rgba(246, 251, 253, 0.2)",
            background: "#161A1D",
            color: "rgba(255, 255, 255, 0.7)",
            zIndex: 10,
            maxHeight: dropdownMaxHeight ? `${dropdownMaxHeight}px` : undefined,
            overflow: "hidden",
          }}
        >
          <div
            style={{
              padding: "8px 0",
              maxHeight: dropdownMaxHeight
                ? `${dropdownMaxHeight}px`
                : undefined,
              overflowY: dropdownMaxHeight ? "auto" : undefined,
              borderRadius: "12px",
            }}
          >
            {options() &&
              options()?.map((option) => {
                const checked = selectedOptions.includes(
                  String(option.documentId)
                );
                return (
                  <Dropdown.Item
                    key={option.documentId}
                    as="div"
                    onClick={(e) => e.stopPropagation()}
                  >
                    <div
                      className={`custom-form-control-label custom-checkbox-row${
                        checked ? " selected" : ""
                      }`}
                    >
                      <div className="custom-form-control-label-title">
                        {option.img && <img src={option.img} alt={"иконка"} />}
                        <span style={{textWrap: "wrap"}}>{option.label}</span>
                      </div>
                      <label className="custom-checkbox">
                        <input
                          type="checkbox"
                          checked={checked}
                          onChange={() =>
                            handleCheckboxChange(String(option.documentId))
                          }
                          tabIndex={0}
                        />
                        <span className="custom-checkbox-box">
                          <svg viewBox="0 0 20 20">
                            <polyline
                              points="5 11 9 15 15 7"
                              stroke="white"
                              strokeWidth="2"
                              fill="none"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </span>
                      </label>
                    </div>
                  </Dropdown.Item>
                );
              })}
            <Dropdown.Item as="div">
              <div
                className="custom-form-control-label custom-checkbox-row"
                style={{justifyContent: "flex-start"}}
              >
                <label
                  className="custom-checkbox"
                  style={{marginRight: "12px"}}
                >
                  <input
                    type="checkbox"
                    checked={selectedOptions.length === options()?.length}
                    ref={(el) => {
                      if (el)
                        el.indeterminate = optionsLevel
                          ? selectedOptions.length > 0 &&
                            selectedOptions.length < optionsLevel
                          : false;
                    }}
                    onChange={handleSelectAll}
                    tabIndex={0}
                    aria-checked={
                      optionsLevel
                        ? selectedOptions.length > 0 &&
                          selectedOptions.length < optionsLevel
                          ? "mixed"
                          : selectedOptions.length === optionsLevel
                          ? "true"
                          : "false"
                        : "false"
                    }
                  />
                  <span className="custom-checkbox-box">
                    <svg viewBox="0 0 20 20">
                      <polyline
                        points="5 11 9 15 15 7"
                        stroke="white"
                        strokeWidth="2"
                        fill="none"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </span>
                </label>
                <div className="custom-form-control-label-title">
                  <span style={{textWrap: "wrap"}}>Выделить все</span>
                </div>
              </div>
            </Dropdown.Item>
          </div>
        </div>
      )}
    </IconContainer>
  );
};
